module.exports = __webpack_public_path__ + "img/head-default.f65da56c.jpg";